// extracted by mini-css-extract-plugin
module.exports = {"modalingredient":"_1tuRcp0w7ef-E8ESA5ODpz"};